import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export function CargoEntryField({ field, value, onChange }) {
  const testid = `cargo-field-${field.key}`;
  if (field.type === "checkbox") {
    return (
      <label className="flex items-center gap-2 cursor-pointer select-none py-2">
        <input type="checkbox" checked={!!value} onChange={(e) => onChange(field.key, e.target.checked)} className="w-4 h-4 accent-emerald-600" data-testid={testid} />
        <span className="text-sm text-slate-700">{field.label}</span>
      </label>
    );
  }
  if (field.type === "select") {
    return (
      <div>
        <Label className="text-xs text-slate-500">{field.label}</Label>
        <select value={value || ""} onChange={(e) => onChange(field.key, e.target.value)} className="mt-1 w-full h-10 rounded-md border border-slate-300 bg-white px-3 text-sm" data-testid={testid}>
          {field.options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>
    );
  }
  if (field.type === "textarea") {
    return (
      <div className="sm:col-span-2 lg:col-span-4">
        <Label className="text-xs text-slate-500">{field.label}</Label>
        <Textarea value={value || ""} onChange={(e) => onChange(field.key, e.target.value)} className="mt-1" rows={2} data-testid={testid} />
      </div>
    );
  }
  return (
    <div>
      <Label className="text-xs text-slate-500">{field.label}</Label>
      <Input type={field.type === "number" ? "number" : field.type === "date" ? "date" : field.type === "time" ? "time" : "text"} value={value ?? ""} onChange={(e) => onChange(field.key, e.target.value)} className="mt-1" data-testid={testid} />
    </div>
  );
}

export const fmtCargoVal = (f, v) => {
  if (f.type === "checkbox") return v ? "Yes" : "No";
  if (v === "" || v === null || v === undefined) return "—";
  return String(v);
};

// Typing an MRN number automatically flags the shipment as T1.
export const withMrnRule = (prev, k, v) => {
  const next = { ...prev, [k]: v };
  if (k === "mrn_no" && String(v || "").trim()) next.customs_t1 = true;
  return next;
};
